/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-underscore-dangle */
import React from 'react';
import { Pagination, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import Accordion from '../../components/accordion';
import Bread from '../../components/breadcrumb';
import Card from '../../components/card';
import { routeGrafica } from '../../utils/routesBread';
import { columnsGraficas, parserDataTabla } from '../../utils/parsers/table';
import { usePagination } from '../../hooks/usePagination';
import { fetchGrafica } from '../../actions/grafica';
import Button from '../../components/button';
import { CREAR_GRAFICA_PATH } from '../../routes/path';
import { parserGrafica } from '../../utils/parsers/grafica';

const Grafica = () => {
  const navigate = useNavigate();
  const {
    dataSource, total, handlePage, page, isLoading
  } = usePagination(fetchGrafica, 'grafica');

  return (
    <div className="page-container">
      <div className="header-nav">
        <Bread routes={routeGrafica} />
        <Button
          type="button"
          text="Crear Gráfica"
          onClick={() => navigate(CREAR_GRAFICA_PATH)}
          color="gray"
        />
      </div>
      <div className="page-container__box">
        <Accordion keyPanel="graficas" header="Gráficas">
          {isLoading
            ? (
              <div className="container-spin">
                <Spin tip="Cargando..." />
              </div>
            )
            : (
              <>
                {dataSource && dataSource.length !== 0 ? (
                  dataSource.map((item) => (
                    <div key={item._id}>
                      <Card
                        columns={columnsGraficas(item)}
                        data={[parserDataTabla(parserGrafica(item))]}
                        header={item.nombre}
                        route="info-grafica"
                      />
                    </div>
                  ))
                ) : <p className="text-nothing">No hay datos para mostrar</p>}
              </>
            )}
        </Accordion>
        {dataSource
        && (
        <div className="page-container__pagination">
          <Pagination current={page} onChange={handlePage} total={total} />
        </div>
        )}
      </div>
    </div>
  );
};

export default Grafica;
